import { getRes } from 'utils/utility';

import customAxios from './customAxios';

class ApiClient {
  async get(url, config = {}, accessToken) {
    const response = await customAxios(accessToken).get(url, config);
    return getRes(response);
  }

  async post(url, data = {}, config = {}, accessToken) {
    const response = await customAxios(accessToken).post(url, data, config);
    return getRes(response);
  }

  async put(url, data = {}, config = {}, accessToken) {
    const response = await customAxios(accessToken).put(url, data, config);
    return getRes(response);
  }

  async delete(url, config = {}, accessToken) {
    const response = await customAxios(accessToken).delete(url, config);
    return getRes(response);
  }
}

export default ApiClient;
